import React from 'react';

import { faGavel } from '@fortawesome/pro-regular-svg-icons';
import { TextField } from '@mui/material';

import StrongTextField from '../components/StrongTextField';

export default {
  name: 'notaires',
  title: 'Notaires',
  icon: faGavel,
  resource: 'notaire',
  primaryKey: 'idNotaire',
  associations: [],
  sort: 'nom',
  head: {
    nom: 'Nom',
    prenom: 'Prenom',
    email: 'Email',
    tel: 'Téléphone',
    adresse: 'Adresse',
    cp: 'Code postal',
    ville: 'Ville',
  },
  list: ({ values, props }) => [
    values.nom,
    values.prenom,
    values.email,
    values.tel,
    values.adresse,
    values.cp,
    values.ville,
  ],
  filter: ({ values, props }) => [
    <StrongTextField name='nom' label='Nom' values={values.nom} {...props} />,
    <StrongTextField name='prenom' label='Prénom' values={values.prenom} {...props} />,
    <StrongTextField name='ville' label='Ville' values={values.ville} {...props} />,
    <StrongTextField name='cp' label='Code postal' values={values.cp} {...props} />,
  ],
  edit: ({ values, props }) => [
    <TextField {...props} fullWidth name='nom' label='Nom' value={values.nom} />,
    <TextField {...props} fullWidth name='prenom' label='Prenom' value={values.prenom} />,
    <TextField {...props} fullWidth name='identifiant' label='Identifiant' value={values.identifiant} />,
    <TextField {...props} fullWidth name='mdp' label='Password' value={values.mdp} type='password' />,
    <TextField {...props} fullWidth name='adresse' label='Adresse' value={values.adresse} />,
    <TextField {...props} fullWidth name='cp' label='Code postal' value={values.cp} />,
    <TextField {...props} fullWidth name='ville' label='Ville' value={values.ville} />,
    <TextField {...props} fullWidth name='email' label='Email' value={values.email} />,
    <TextField {...props} fullWidth name='tel' label='Telephone' value={values.tel} />,
    <TextField {...props} fullWidth name='fax' label='Fax' value={values.fax} />,
  ],
  add: true,
  show: true,
  popup: true,
  remove: true,
};
